import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Greetings() {
  return <ImageCollectionPage title="Greetings" path="/culture/greetings" collection="culture_greetings" />;
}
